import { type Common } from './common.js';
import { type CreateValues, type ProvisionalPatient } from './models/patient/provisional.js';

interface SendResponse {
  success: boolean;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async createBulk(payload: {
    previsitLinkId: string;
    patients: CreateValues[];
  }): Promise<ProvisionalPatient[]> {
    const url = this.common.constructPath(`/provisional-patients`);
    return await this.common.postJSON(url, payload);
  }

  async sendText(id: string, payload: { checkRateLimiter?: boolean } = {}): Promise<SendResponse> {
    const url = this.common.constructPath(`/provisional-patients/${id}/text`);
    return await this.common.postJSON(url, payload);
  }

  async sendEmail(id: string, payload: { checkRateLimiter?: boolean } = {}): Promise<SendResponse> {
    const url = this.common.constructPath(`/provisional-patients/${id}/email`);
    return await this.common.postJSON(url, payload);
  }
}
